<!-- Agency Details Header Section -->
<div class="agency-details-container">
  <div class="agency-header">
    <div class="header-content">
      <div class="agency-info">
        <h1 class="agency-name">
          <span class="company-icon">🏢</span>
          {{ agencyData?.name || 'Loading...' }}
        </h1>
        <p class="agency-subtitle">Agency Account Details & Member Management</p>
      </div>
      <div class="agency-actions">
        <button class="btn-action back-button" (click)="goBack()">
          <span class="icon">←</span>
          Back
        </button>
      </div>
    </div>
  </div>
  <div class="agency-cards" *ngIf="agencyData">
    <!-- Basic Information -->
    <div class="detail-card">
      <div class="card-header">
        <span class="card-icon">📋</span>
        <h3>Basic Information</h3>
      </div>
      <div class="card-content">
        <div class="info-item">
          <label>Plan:</label>
          <span class="plan-badge" [class]="agencyData.plan">
            {{ getPlanLabel(agencyData.plan) }}
          </span>
        </div>
        <div class="info-item">
          <label>Status:</label>
          <span class="status-badge" [class]="agencyData.status">
            {{ agencyData.status | uppercase }}
          </span>
        </div>
      </div>
    </div>
    <!-- Legal Information -->
    <div class="detail-card">
      <div class="card-header">
        <span class="card-icon">🏛️</span>
        <h3>Legal Information</h3>
      </div>
      <div class="card-content">
        <div class="info-item" *ngIf="agencyData.panNumber">
          <label>PAN Number:</label>
          <span class="code-text">{{ agencyData.panNumber }}</span>
        </div>
      </div>
    </div>
    <!-- Address Information -->
    <div class="detail-card">
      <div class="card-header">
        <span class="card-icon">📍</span>
        <h3>Address Information</h3>
      </div>
      <div class="card-content" *ngIf="agencyData.address">
        <div class="address-block">
          <p>{{ agencyData.address.street }}</p>
          <p>{{ agencyData.address.city }}, {{ agencyData.address.state }}</p>
          <p>{{ agencyData.address.pincode }}</p>
        </div>
      </div>
    </div>
    <!-- Members Overview -->
    <div class="detail-card stats-card">
      <div class="card-header">
        <span class="card-icon">👥</span>
        <h3>Members Overview</h3>
      </div>
      <div class="card-content">
        <div class="stats-grid">
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.total }}</span>
            <span class="stat-label">TOTAL MEMBERS</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.active }}</span>
            <span class="stat-label">ACTIVE</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.inactive }}</span>
            <span class="stat-label">INACTIVE</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.suspended }}</span>
            <span class="stat-label">SUSPENDED</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Loading/Error as before -->
</div>
<div class="members-table-container">
  <div class="table-section-header">
    <h2>
      <span class="section-icon">👥</span>
      Agency Members
    </h2>
    <p>Manage and view all members of this agency account</p>
  </div>
  <tt-shared-table name="agencymembers"></tt-shared-table>
</div>
